/**
 * News V2 Phase 1 — edition-based API (grounded, cached).
 */
import api from '../utils/api';

const base = '/api/insights/v2';

export async function getNewsTeaser() {
  const res = await api.get(`${base}/news/teaser`);
  return res.data;
}

export async function getNewsEdition() {
  const res = await api.get(`${base}/news/edition`);
  return res.data;
}

/** Opt-in rolling 7-day digest (cached ~24h server-side). */
export async function getNewsWeeklyDigest() {
  const res = await api.get(`${base}/news/weekly-digest`);
  return res.data;
}

export async function refreshNewsEdition() {
  const res = await api.post(`${base}/news/refresh`);
  return res.data;
}

export async function trackNewsV2Event(payload) {
  try {
    await api.post(`${base}/news/track`, payload);
  } catch {
    /* non-blocking */
  }
}
